export function LoadingScreen() {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#FAF6EF',
    }}>
      <div style={{ textAlign: 'center' }}>
        <img src='/logo-light.png' alt='DriveTrack' height={52} style={{ display: 'block', margin: '0 auto 14px' }} />
        <div style={{ font: '400 13px Inter,sans-serif', color: 'rgba(27,42,74,0.5)' }}>
          Loading…
        </div>
      </div>
    </div>
  )
}
